import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { shortDate } from "@/lib/format";

const NAMES = { nba: "NBA.com", rotowire: "RotoWire", noon: "12:00 snapshot", manual: "NBACUBE admin" };

function AdminVsFeed({ v }) {
  if (!v?.team_games) {
    return <p className="aa-empty" data-testid="lsa-admin-empty">No admin-set fives with an official ESPN five yet. Set a five in Rotation Sim and it is scored here after tip-off.</p>;
  }
  const pct = (n) => `${Math.round((100 * n) / v.team_games)}%`;
  const right = (n) => `${Math.round((100 * n) / (5 * v.team_games))}%`;
  return (
    <div className="aa-cards" data-testid="lsa-admin-vs-feed">
      <div className="aa-card" data-testid="lsa-admin-exact"><span>Admin five · exact</span><strong>{pct(v.admin_exact)}</strong><em>{v.admin_exact}/{v.team_games} team-games · {right(v.admin_starters_right)} starters right</em></div>
      <div className="aa-card" data-testid="lsa-feed-exact"><span>Feed on same games · exact</span><strong>{pct(v.feed_exact)}</strong><em>{v.feed_exact}/{v.team_games} team-games · {right(v.feed_starters_right)} starters right</em></div>
      <div className="aa-card" data-testid="lsa-admin-record"><span>Admin vs feed</span><strong>{v.admin_better}–{v.feed_better}</strong><em>games admin was closer – feed was closer ({v.team_games - v.admin_better - v.feed_better} ties)</em></div>
    </div>
  );
}

// How often each expected-lineup source matched ESPN's official starting five.
export function LineupSourceAccuracy() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/lineups/source-accuracy").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const total = d.rows.length;
  return (
    <section className="aa-section" data-testid="lineup-source-accuracy">
      <h2>Expected lineups vs ESPN</h2>
      <p className="aa-explainer">The expected fives used before ESPN confirms (NBACUBE admin five if set, else NBA.com, then RotoWire), checked against the official starters.</p>
      <h3 className="aa-sub">Admin five vs feed</h3>
      <AdminVsFeed v={d.admin_vs_feed} />
      {total === 0 ? (
        <p className="aa-empty" data-testid="lsa-empty">No team-games with both an expected five and an official ESPN five yet. This fills in from tonight.</p>
      ) : (
        <>
          <h3 className="aa-sub">All sources</h3>
          <div className="aa-cards">
            {Object.entries(d.sources).filter(([, s]) => s.team_games).map(([k, s]) => (
              <div key={k} className="aa-card" data-testid={`lsa-${k}`}>
                <span>{NAMES[k] || k} · exact five</span><strong>{s.exact_pct}%</strong>
                <em>{s.exact}/{s.team_games} team-games · {s.starters_right_pct}% starters right</em>
              </div>
            ))}
          </div>
          <div className="aa-table-scroll">
            <table className="aa-table" data-testid="lsa-table">
              <thead><tr><th>Date</th><th>Team</th><th>Source</th><th className="r">Matched</th><th className="r">Feed</th></tr></thead>
              <tbody>
                {d.rows.slice(0, 40).map((r) => (
                  <tr key={`${r.source}-${r.game_id}-${r.team}`} data-testid={`lsa-row-${r.source}-${r.game_id}-${r.team}`}>
                    <td className="aa-date">{shortDate(r.game_day)}</td>
                    <td>{r.team}</td>
                    <td>{NAMES[r.source] || r.source}</td>
                    <td className={`r aa-number ${r.matched === 5 ? "aa-good" : "aa-bad"}`}>{r.matched}/5</td>
                    <td className="r aa-number">{r.feed_matched != null ? `${r.feed_matched}/5 ${NAMES[r.feed_source]}` : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}
